export default {
  zh: 'CN',
  en: 'EN',
  save: '保存',
  cancel: '取消',
  confirm: '确认',
  user: '用户',
  logout: '登出',
  info: '基本资料',
  workInfo: '工作信息',
  job: '职业信息',
  setting: '安全设置',
  account: '账号信息',
  email: '邮箱绑定',
  phone: '手机绑定',
  emailBind: '您已绑定了邮箱',
  phoneBind: '您已绑定了手机',
  password: '登录密码',
  setted: '已设置',
  passwordTip: '安全性高的密码可以使帐号更安全。建议您定期更换密码，设置一个包含字母，符号或数字中至少两项且长度超过6位的密码。',
  third: '第三方账户绑定',
  office: 'Office365账号',
  weChat: '微信账号',
  boundAccount: '绑定账号',
  bound: '绑定',
  remove: '解绑',
  follow: '关注微信公众号',
  followInfo: '扫描二维码，关注微信公众号，查看最新动态和消息',
  followed: '已关注账号',
  upload: '点击上传',
  noBound: '未绑定',
  noBoundEmail: '邮箱未绑定',
  noBoundPhone: '手机未绑定',
  imageCropping: '图片裁剪',
  choosePicture: '选择图片',
  basic: {
    last: '名',
    first: '姓',
    middle: '中间名',
    full: '全名',
    en: '英文名',
    used: '曾用名',
    gender: '性别',
    birth: '生日',
    nationality: '国籍',
    documentType: '证件类型',
    certificateNumber: '证件号',
    phone: '学校电话',
    email: '邮箱',
    homeTel: '家庭电话',
    address: '地址'
  },
  work: {
    id: '老师编号',
    status: '工作状态',
    position: '岗位',
    time: '入职时间'
  },
  position: {
    id: '家长编号',
    work: '职业',
    company: '工作单位'
  },
  title: {
    title1: '提示',
    title2: '绑定操作确认',
    title3: '请输入要绑定的邮箱',
    title4: '请输入要绑定的手机号码',
    title5: '为确认是您本人操作，请完成身份验证',
    title6: '请输入新的绑定邮箱',
    title7: '请输入新的手机号码'
  },
  tip: {
    email: '邮箱',
    phone: '手机号码',
    code: '验证码',
    getCode: '点击获取',
    new: '新密码',
    confirm: '确认密码',
    tips0: '请输入正确的邮箱地址',
    tip1: '确定要解除绑定？',
    tip2: '绑定后，您可以使用该第三方账户登录到系统',
    tip3: '手机绑定成功！',
    tip4: 'Office365账号验证成功，确定绑定'
  },
  choose: {
    tip1: '请选择性别',
    tip2: '选择日期',
    tip3: '请选择国籍',
    tip4: '请选择证件类型',
    tip5: '请选择省市'
  }
}



// WEBPACK FOOTER //
// ./src/views/user/lang/zh.js